import { render, staticRenderFns } from "./AccountApp.vue?vue&type=template&id=3dde8315&"
import script from "./AccountApp.vue?vue&type=script&lang=js&"
export * from "./AccountApp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports